import { boolean, object, optional, string } from 'zod';

// FIXME: 타입 정의 정리 & Import depth changed after feature-based restructuring
import { type TreeMenuItem } from '../../features/category-tree';

export const SCHOOL_TYPE_REQUIRED_MESSAGE = 'School type is required' as const;
export const GRADE_REQUIRED_MESSAGE = 'Grade is required' as const;
export const SEMESTER_REQUIRED_MESSAGE = 'Semester is required' as const;

export type SchoolInfoErrorMessage =
  | typeof SCHOOL_TYPE_REQUIRED_MESSAGE
  | typeof GRADE_REQUIRED_MESSAGE
  | typeof SEMESTER_REQUIRED_MESSAGE;

export type SchoolInfoNodes = {
  schoolNodes: TreeMenuItem[];
  gradeNodes: TreeMenuItem[];
  semesterNodes: TreeMenuItem[];
};

const BuildSchoolInfoSchema = object({
  schoolTypeId: string().min(1, SCHOOL_TYPE_REQUIRED_MESSAGE),
  gradeId: optional(string()),
  semesterId: optional(string()),
  isLastSchoolInfoSaved: boolean(),
});

export type BuildSchoolInfoSchemaType = Zod.infer<typeof BuildSchoolInfoSchema>;

export const getBuildSchoolInfoSchema = (schoolInfoNodes: SchoolInfoNodes) => {
  const { schoolNodes, gradeNodes, semesterNodes } = schoolInfoNodes;
  return BuildSchoolInfoSchema.refine(d => {
    const dataset = d as BuildSchoolInfoSchemaType;
    const schoolTypeId = dataset.schoolTypeId;
    if (schoolNodes.length > 0 && !schoolTypeId) {
      return false;
    }
    return true;
  }, SCHOOL_TYPE_REQUIRED_MESSAGE)
    .refine(d => {
      const dataset = d as BuildSchoolInfoSchemaType;
      const gradeId = dataset.gradeId;
      if (gradeNodes.length > 0 && !gradeId) {
        return false;
      }
      return true;
    }, GRADE_REQUIRED_MESSAGE)
    .refine(d => {
      const dataset = d as BuildSchoolInfoSchemaType;
      const semesterId = dataset.semesterId;
      if (semesterNodes.length > 0 && !semesterId) {
        return false;
      }
      return true;
    }, SEMESTER_REQUIRED_MESSAGE);
};
